{
	"invalidFileFormat": "Formato de arquivo inválido, formatos válidos: {{formats}}",
	"multipleFilesUploaded": "Múltiplos arquivos enviados",
	"remove": "Remover"
}
